import * as StopoverHotelsActions from '../actions/stopover-hotels.actions';
import * as StopoverHotelsState from '../states/stopover-hotels.state';

export class State extends StopoverHotelsState.State { }

const initialState: StopoverHotelsState.State = StopoverHotelsState.initialState;
/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {StopoverHotelsActions.Actions} action
 * @returns {StopoverHotelsState.State}
 */
export function reducer(state = initialState, action: StopoverHotelsActions.Actions): StopoverHotelsState.State {
	switch (action.type) {
		case StopoverHotelsActions.ActionTypes.LOADING:
			state = Object.assign({}, state, { ...initialState, loading: true });
			return state;
		case StopoverHotelsActions.ActionTypes.PUT_FILTERS:
			state = Object.assign({}, state, { loading: false, filters: action.payload });
			return state;
		case StopoverHotelsActions.ActionTypes.PUT_HOTELS:
			state = Object.assign({}, state, { loading: false, hotels: action.payload });
			return state;
		case StopoverHotelsActions.ActionTypes.PUT_FEATURE_HOTELS:
			state = Object.assign({}, state, { loading: false, feature_hotels: action.payload });
			return state;
		case StopoverHotelsActions.ActionTypes.PUT_STOPOVER:
			state = Object.assign({}, state, { loading: false, stopover: action.payload });
			return state;
		case StopoverHotelsActions.ActionTypes.PUT_CITY_ID:
			state = Object.assign({}, state, { loading: false, city_id: action.payload['id'] });
			return state;
		case StopoverHotelsActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		default:
			return state;
	}
}

export const getLoading = (state: StopoverHotelsState.State) => state.loading;
export const getHotels = (state: StopoverHotelsState.State) => state.hotels;
export const getFeatureHotels = (state: StopoverHotelsState.State) => state.feature_hotels;
export const getFilters = (state: StopoverHotelsState.State) => state.filters;
export const getStopover = (state: StopoverHotelsState.State) => state.stopover;
export const getCityId = (state: StopoverHotelsState.State) => state.city_id;